/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Brand_DescriptionInputs */

const en_meta_brand_description = /** @type {(inputs: Meta_Brand_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Lindevo identity: the connected-L mark and its four cuts, the one teal that means the system is answering, and a single typeface from caption to headline.`)
};

const lv_meta_brand_description = /** @type {(inputs: Meta_Brand_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lindevo identitāte: savienotā L zīme un tās četri varianti, tirkīza tonis, kas nozīmē, ka sistēma atbild, un viens burtveidols no paraksta līdz virsrakstam.`)
};

/**
* | output |
* | --- |
* | "The Lindevo identity: the connected-L mark and its four cuts, the one teal that means the system is answering, and a single typeface from caption to headline." |
*
* @param {Meta_Brand_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_brand_description = /** @type {((inputs?: Meta_Brand_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Brand_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_brand_description(inputs)
	return en_meta_brand_description(inputs)
});